import { render, staticRenderFns } from "./SmsAccountUsage.vue?vue&type=template&id=bc256fe6&scoped=true"
import script from "./SmsAccountUsage.vue?vue&type=script&lang=js"
export * from "./SmsAccountUsage.vue?vue&type=script&lang=js"
import style0 from "./SmsAccountUsage.vue?vue&type=style&index=0&id=bc256fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc256fe6",
  null
  
)

export default component.exports